
  import React from "react"
  import Component from "/Users/christianwolter/Coding/privat_projects/christian-wolter/gastrap_backup/gatstrap_hs/src/layouts/index.js"
  import data from "/Users/christianwolter/Coding/privat_projects/christian-wolter/gastrap_backup/gatstrap_hs/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js